import { StylesProvider } from '@material-ui/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';
import { PostHogWrapper } from './contexts/posthog-wrapper';

const client = () => {
  ReactDOM.render(
    <React.StrictMode>
      <PostHogWrapper>
        <StylesProvider injectFirst>
          <App />
        </StylesProvider>
      </PostHogWrapper>
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

export default client;
